export default "__VITE_ASSET__DuUWfDcm__"